import { useEffect } from 'react';
import type { ShipperDetailsResponse } from 'src/apis/organisation-service/types';
import type {
  OptionalOrganisationDetailsRequest,
  OrganisationDetailsRequest,
} from 'src/apis/organisation-service/use-organisation-details';
import { useAxios } from 'src/hooks/use-axios';

export function useOptionalShipperDetails({
  organisationDetails,
}: {
  organisationDetails:
    | OrganisationDetailsRequest
    | OptionalOrganisationDetailsRequest;
}) {
  const shipperDetails = useAxios(
    (axios, baseConfig, url: string) =>
      axios.request<ShipperDetailsResponse>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!organisationDetails?.response?.data._links.shipperDetails?.href)
      return;
    shipperDetails.execute(
      organisationDetails.response.data._links.shipperDetails.href
    );
    // oxlint-disable-next-line exhaustive-deps
  }, [organisationDetails?.response]);

  if (!organisationDetails?.response?.data._links.shipperDetails?.href) return;

  return shipperDetails;
}

export type OptionalShipperDetailsRequest = ReturnType<
  typeof useOptionalShipperDetails
>;
